export enum ParameterLevel {
  VERY_LOW = 'very_low',
  LOW = 'low',
  MID = 'mid',
  HIGH = 'high',
  VERY_HIGH = 'very_high',
}
